// useFileDownloader.js
import JSZip from "jszip";
import { saveAs } from "file-saver";

export const useFileDownloader = () => {
    const downloadFile = async (url:string) => {
      const res = await fetch(url);
      const blob = await res.blob();
      const filename = url.split("/").pop() ?? "File";
      const blobUrl = URL.createObjectURL(blob);
  
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      a.click();
  
      URL.revokeObjectURL(blobUrl);
    };
  
    const downloadFiles = async (urls:string[]) => {
      if (urls.length === 1) return downloadFile(urls[0]);
      const zip = new JSZip();
      for (const url of urls) {
       await fetch(url).then(res => res.blob()).then(blob => {
        zip.file(url.split("/").pop() ?? "File", blob);
       });
      }
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "files.zip");
    };
  
    return { downloadFile,  downloadFiles };
};
  